import { RegularDateFormat } from '@anecdotes/design-system/constants';
import { ChangeDetectionStrategy, Component, Input, OnChanges, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-date-view',
  templateUrl: './date-view.component.html',
  styleUrls: ['./date-view.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DateViewComponent implements OnChanges { 
  @Input()
  dateFormat = RegularDateFormat;

  @Input()
  date: string | Date;

  @Input()
  descriptionTranslationKey: string;

  @Input()
  icon: string;

  @Input()
  iconTooltip: string;

  @Input()
  boldValue = false;
  
  displayDate: Date | string;

  ngOnChanges(changes: SimpleChanges): void {
    if ('date' in changes) {
      this.displayDate = this.date;
    }
  }
}
